import {
  Button,
  Flex,
  ModalBody,
  ModalDialog,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  Typography,
} from "@aircall/tractor";
import styled from "@xstyled/styled-components";

import { SubmitButton } from "@/components/SubmitButton";

import { ConfirmationModalProps } from ".";

const StyledModalBody = styled(ModalBody)`
  box-shadow: none;
`;

export function ConfirmationModal({
  title,
  description,
  show,
  actions,
  loading,
  onHide,
}: ConfirmationModalProps) {
  return (
    <ModalDialog
      show={show}
      onHide={onHide}
      data-test="delete-scorecard-delete-modal"
      size="small"
    >
      <ModalHeader>
        <ModalTitle>{title}</ModalTitle>
      </ModalHeader>
      <StyledModalBody>
        <Typography variant="bodyMediumM">{description}</Typography>
      </StyledModalBody>
      <ModalFooter p="xxs">
        <Flex gap="s">
          {actions.map((action, index) => {
            if (index === 0) {
              return (
                <Button
                  key={index}
                  type="button"
                  disabled={loading}
                  size="regular"
                  mode="ghost"
                  variant="secondary"
                  {...action}
                >
                  {action.label}
                </Button>
              );
            }

            return (
              <SubmitButton
                key={index}
                type="button"
                loading={loading}
                disabled={loading}
                size="regular"
                mode="fill"
                variant="primary"
                {...action}
              >
                {action.label}
              </SubmitButton>
            );
          })}
        </Flex>
      </ModalFooter>
    </ModalDialog>
  );
}
